<div class="payg-message-dialog">

  <div class="message-icon"
       [ngClass]="'message-icon-' + data.type">

    <mat-icon *ngIf="data.type === 'success'">
      check_circle
    </mat-icon>

    <mat-icon *ngIf="data.type === 'error'">
      error
    </mat-icon>

    <mat-icon *ngIf="data.type === 'info'">
      info
    </mat-icon>

  </div>

  <h2>{{ data.title }}</h2>

  <div class="message-content">
    {{ data.message }}
  </div>

  <div class="message-actions">

    <button mat-raised-button
            color="primary"
            (click)="close()">

      OK

    </button>

  </div>

</div>
